import type { CoaPreviewMode } from "./applyCoaPreviewTagCopy";

export interface ArchivedApplyState {
    // The account's actual archived state (post-apply in the historical
    // snapshot, current in the live/as-is preview).
    isDisabled: boolean;
    // True only when the apply itself transitioned an existing account to
    // archived (never set by the as-is/AddClient preview).
    wasArchivedByApply: boolean;
}

// Single source of truth for the "Archived" tag AND the "Archived" Updates
// filter so the two never diverge. The driver differs by mode:
// - preview (live wizard + AddClient as-is): actual archived state, so
//   genuinely disabled accounts always show the tag.
// - historical (Activity drawer): only accounts THIS apply archived, since the
//   frozen snapshot's `isDisabled` also covers pre-existing disabled accounts.
export function isArchivedForMode(
    state: ArchivedApplyState,
    mode: CoaPreviewMode,
): boolean {
    return mode === "historical" ? state.wasArchivedByApply : state.isDisabled;
}

// Complement of `isArchivedForMode`, so "Active" and "Archived" partition the
// rows in both modes. Without this, a historical account that was already
// disabled before the apply matched neither filter and was unreachable.
export function isActiveForMode(
    state: ArchivedApplyState,
    mode: CoaPreviewMode,
): boolean {
    return !isArchivedForMode(state, mode);
}
